import {apiURI} from "../shared/api.settings";
//import {apiGenerateURI} from "../shared/api.settings";

class TextGenerationService {
    
    static GetTextGenerationByIdentifier = async (userId, identifier, token) => {
        return fetch(`${apiURI}/generation/text/user/?userId=${userId}/textgen_id=${identifier}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((response) => response.json());
    }

    static GetUserTextGenerations = async (userId, page = 0, pageSize = 48, token) => {
        return fetch(`${apiURI}/generation/text/user?userId=${userId}&page=${page}&pageSize=${pageSize}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((response) => response.json());
    }

    static GetUserTextGenerationsByImageId = async (userId, imageId, page = 0, pageSize = 48, token) => {
        return fetch(`${apiURI}/generation/text/user/${userId}/image/${imageId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((response) => response.json());
    }

    /*
    static GetUserImagesWithTextGenerations = async (userId, page = 0, pageSize = 48, token) => {
        return fetch(`${apiURI}/image/user/stories?userId=${userId}&page=${page}&pageSize=${pageSize}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((response) => response.json());
    }
    */

    static GetUserTextGenerationsByTag = async (userId, tag, tagValue, page = 0, pageSize = 48, token) => {
        return fetch(`${apiURI}/generation/text/user/${userId}/tag/${tag}/${tagValue}?page=${page}&pageSize=${pageSize}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((response) => response.json());
    }

    static GetUserTextGenerationsByTextType = async (userId, textType, page = 0, pageSize = 48, token) => {
        return fetch(`${apiURI}/generation/text/user/${userId}/type/${textType}?page=${page}&pageSize=${pageSize}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((response) => response.json());
    }

    static SaveTextGenerationToUserImage = async (userId,imageId, productId) => {
        // console.log("ProductService.PurchaseImageUsingCredits: ", userId);
        // console.log("ProductService.PurchaseImageUsingCredits: ", productId);
        // console.log("ProductService.PurchaseImageUsingCredits: ", imageId);
    
        var body = 
          {
            "userId": userId,
            "productType": 0, //text generation
            "numTokens": 1,
            "assetId": imageId,
            "productId": `${productId}` // class of text gen product
          };
    
        // console.log("ProductService - PurchaseImageUsingCredits - body: ", body);
        return fetch(`${apiURI}/product/text/purchase/credits`, {
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }).then((response) => response.json());
      }

    static GenerateTextFromImageContext = async (context, imageData, themes) => {

        console.log("GenerateTextFromImageContext:", context, imageData, themes);

        // sample payload
        /*
            {
                "prompt":"Doug the barbarian was a well loved member of the community, well respected for his work ethic and his love for animals, but harbored a horrible secret.",
                "max_new_tokens":1024,
                "temperature":0.3,
                "top_k":0,
                "top_p":0.9,
                "do_sample":true,
                "repetition_penalty":1.0
            }
        */

        // sample url
        // http://smartmonster:8081/capability/text/generation/mistral/7b/chat
        /*
        let colorTags = imageData.tags.filter((tag) => tag.startsWith("color:"));        
        let materialsTags = imageData.tags.filter((tag) => tag.startsWith("materials:"));
        let topicTags = imageData.tags.filter((tag) => tag.startsWith("topic:"));
        //let categoryTags = imageData.tags.filter((tag) => tag.startsWith("category:"));
        //let heightTags = imageData.tags.filter((tag) => tag.startsWith("height:"));
        //let widthTags = imageData.tags.filter((tag) => tag.startsWith("width:"));
        let tags = imageData.tags.filter((tag) => tag.startsWith("tag:"));
        let locations = imageData.tags.filter((tag) => tag.startsWith("location:"));
        
        // TODO - Add tagsExtra to the prompt
        let promptPrefix = "Generate a " + imageData.category + " " + context +  " establishing context with the following ";
        
        // create delimited string of color tags after joining them, remove the 'color:' prefix
        let colorTagsString = colorTags.join(", ").r
        // create delimited string of materials tags after joining them, remove the 'materials:' prefix
        let materialsTagsString = materialsTags.join(", ").replace("materials:","");
        // create delimited string of topic tags after joining them, remove the 'topic:' prefix
        let topicTagsString = topicTags.join(", ").replace("topic:","");
        // create delimited string of tags after joining them, remove the 'tag:' prefix
        let tagsString = tags.join(", ").replace("tag:","");
        // create delimited string of locations after joining them, remove the 'location:' prefix
        let locationsString = locations.join(", ").replace("location:","");
            
        console.log("GenerateTextFromImageContext colorTagsString:", colorTagsString);
        console.log("GenerateTextFromImageContext materialsTagsString:", materialsTagsString);
        console.log("GenerateTextFromImageContext topicTagsString:", topicTagsString);
        console.log("GenerateTextFromImageContext tagsString:", tagsString);
        console.log("GenerateTextFromImageContext locationsString:", locationsString);

          let promptComplete = "[INST] " + promptPrefix + 
            (colorTags.length > 0) ? " colors:" + colorTags.join(", ").replace("color:","") : "" + 
            (materialsTags.length > 0) ? " and materials: " + materialsTags.join(", ") : "" + 
            (topicTags.length > 0) ? " and topics: " + topicTags.join(", ") : "" +       
            (tags.length > 0) ? " and tags: " + tags.join(", ") : "" + 
            (themes.length > 0) ? " and incorporate the following thematic elements: " + themes.split(", ") : "" +
            (locations.length > 0) ? " and locations: " + locations.join(", ") : "" +
            + " [/INST]";
        
*/
        // TODO - Add tagsExtra to the prompt
        let promptPrefix = "Generate a " + imageData.category + " " + context;
        let promptComplete = "[INST] " + promptPrefix + " [/INST]";

        console.log("GenerateTextFromImageContext promptComplete:", promptComplete);

        let payload = {
            prompt: promptComplete,
            max_new_tokens: 1024,
            temperature: 0.3,
            top_k: 0,
            top_p: 0.9,
            do_sample: true,
            repetition_penalty: 1.0
        };

        console.log("GenerateTextFromImageContext payload:", payload);

        return fetch(`${apiURI}/capability/text/generation/mistral/7b/chat`, {
            method: 'POST',
            mode: "no-cors", // no-cors, *cors, same-origin
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload),
        }).then((response) => response.json());

    }
}

export default TextGenerationService;